import { Box, IconButton } from "@mui/material";
import { useRatingThumbsStyles } from "./RatingThumbs.style";
import { LikeIcon } from "icons";
import { IEvaluation } from "state/ReviewState";

interface IProps {
	evaluation: IEvaluation | null;
	setEvaluation: (evaluation: IEvaluation) => void;
}

const RatingThumbs = ({ evaluation, setEvaluation }: IProps) => {
	const { classes, cx } = useRatingThumbsStyles();

	return (
		<Box className={classes.buttonsWrapper}>
			<IconButton
				className={cx(classes.iconButton, evaluation === "dislike" && classes.iconButtonActive)}
				onClick={() => setEvaluation("dislike")}
				data-testid="dislike-button"
				size="large"
			>
				<LikeIcon className={classes.dislike} />
			</IconButton>
			<IconButton
				className={cx(classes.iconButton, evaluation === "like" && classes.iconButtonActive)}
				onClick={() => setEvaluation("like")}
				data-testid="like-button"
				size="large"
			>
				<LikeIcon className={classes.likeIcon} />
			</IconButton>
		</Box>
	);
};

export default RatingThumbs;
